 // common functions

// export function itemClick(item){

//     // console.log('clicked');
//     // console.log(item);
//     console.log(item.id);
    
//     if(typeof (item.id) !=="undefined" && item.id>-1){
//         //navigate
//         console.log('nav to:'+ item.id);
//         //window.history.pushState({}, "/"+ item.id, window.location.origin + "/"+ item.id);
//         window.router.navigate("/view/"+ item.id)
//         //nav.navigate("/view/"+ item.id);
//     }else{
//         //action
//         console.log('do action')
//         processLink(item,item.label);
//     }
// }

export function hideSplash(){
    let splash = document.getElementById('splash');

    if (CheckFlutter()) {
        splash.style.display = 'none';
        //set color
        if (typeof FlutterColor !== 'undefined') {

            var ucolor = userColor;

            if (ucolor.indexOf('#') > -1) {
                ucolor = ucolor.split('#')[1];
            }

            var message = JSON.stringify({ usercolorhex: userColor, usercolorint: '0xFF'+ ucolor });

            FlutterColor.postMessage(message)
        }

        FlutterApp.postMessage('Hide Flutter Splash');
    }else{
        splash.className = "hidden";
    }
}
export function getSvgIcon(id){
    //console.log(id);
    //console.log(svgIcons);
    //console.log(svgIcons.length);
    const icon = svgIcons.find(x => x.id===id);

   
        return "<svg x='0px' y='0px' viewBox='0 0 200 200'>"+ icon.p +"</svg>";
    
    //console.log(icon);
}

export function getSvgPath(id){
    const icon = svgIcons.find(x => x.id===id);
    return icon.p;
}

export function elementIdExists(el){
    if(document.getElementById(el)){
        return true;
    }else{
        return false;
    }
}



function OpenIframeOrNot(){

}



//Create URL for Maps
function GetMapURL(parameters) {

    console.log(parameters);

    var url = "maps://maps.apple.com/?z=7&q=loc:";

    // if (parameters.origin !== undefined) {
    //     //route
    //     if (idevice)
    //     {
    //         url = "maps://maps.apple.com/maps?saddr=" + parameters.origin.lat + "," + parameters.origin.lon + "&daddr=" + parameters.end.lat + "," + parameters.end.lon;
    //     } else {
    //         url = "https://maps.google.com?saddr=" + parameters.origin.lat + "," + parameters.origin.lon + "&daddr=" + parameters.end.lat + "," + parameters.end.lon;
    //     }
    // } else {
    //     if (parameters.lat === undefined) {
          
    //         //multi
    //         if (idevice) {
    //             url += parameters[0].lat + "," + parameters[0].lon;
    //         } else {
    //             url = "https://www.google.com/maps?z=7&q=loc:" + parameters[0].lat + "," + parameters[0].lon;
    //         }

    //         url += "|" + parameters[1].lat + "," + parameters[1].lon;

    //     } else {
        
            //single
            if (idevice) {
                url += parameters.lat + "," + parameters.lon;
            } else {
                url = "https://www.google.com/maps?z=7&q=loc:" + parameters.lat + "," + parameters.lon;
            }
        // }
    // }

    document.location = url;

}

const BaseImageUrl = "core.igenapp.com";
const CDNImageUrl = "igstatic.azureedge.net";//"igenappsfiles.blob.core.windows.net"; 
const DataCDNUrl = "https://igappfiles.azureedge.net"; //"https://igappsfiles.blob.core.windows.net";

export function SetCDNImages(images) {
    for (var i in images) {
        if (images[i] != null) {
            if (images[i].source != null) {
                if (images[i].source.url) {

                    images[i].source.url = images[i].source.url.replace(BaseImageUrl, CDNImageUrl).replace("http://", "https://");
                }
            }
            if (images[i].thumbnails != null) {
                if (images[i].thumbnails.thumb160 != null) {
                    if (images[i].thumbnails.thumb160.url) {
                        images[i].thumbnails.thumb160.url = images[i].thumbnails.thumb160.url.replace(BaseImageUrl, CDNImageUrl).replace("http://", "https://");
                    }
                }
            } 
        }
    }
}

export function SetCDNImage(imagesrc){
    return imagesrc.toString().replace(BaseImageUrl, CDNImageUrl).replace("http://", "https://");
}

export function FontIconsLoaded() {
    let fontnum = 0;
    let i;
    for (i = 0, fontsNeeded.length; i < fontsNeeded.length; i++) {
        let font = fontsNeeded[i];

        if (font === "" || font === "kendoui") {
            fontnum++;
        } else {

            switch (font) {
                case "igenapps":
                    font = "igenapps";
                    break;
                case "igenkit":
                    font = "igen-kit";
                    break;
                case "location-weather":
                    font = "igen-location";
                    break;
                case "transportation":
                    font = "igen-transport";
                    break;
                case "health-fitness":
                    font = "igen-health";
                    break;
                default:
                    font = "igen-" + font;
                    break;
            }
            const element = document.querySelector("html")
            
            //wf-igengeneral-n4-active
            if (element.classList.contains("wf-" + font.replace("-", "") + "-n4-active") || element.classList.contains("fa-events-typefaces-" + font + "-normal-normal-ready")) {
                fontnum++;
                console.log('font' + font + 'ready');
            } else {
                console.log('font' + font + 'not ready');
            }
            //if ($("html").hasClass("fa-events-typefaces-" + font + "-normal-normal-ready")) {
            //    fontnum++;
            //    console.log('font' + font + 'ready');
            //} else {
            //    console.log('font' + font + 'not ready');
            //}
        }
    }
    console.log(fontschecked);
    if (fontnum === fontsNeeded.length) {
        console.log('all fonts loaded');
        fontschecked = -1;
        return true;
    } else {
        fontschecked++;
        if (fontschecked < 8) {
            console.log('not all fonts loaded');
            return false;
        } else {
            console.log('font checking done');
            fontschecked = -1;
            return true;
        }
    }
}


//init things on app start up
//appcolorbackground
